import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"20px","font-size":"16px"} }
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      title: "请输入验证码 ",
      "close-on-click-modal": false,
      "before-close": _ctx.close,
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleLogin
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, "提示： 你好！" + _toDisplayString(_ctx.name) + "用户，验证码已经发往您的邮箱" + _toDisplayString(_ctx.email) + "，若邮箱地址有误，请联系管理员。", 1),
          _createVNode(_component_el_input, {
            ref: "verifiCodeRef",
            modelValue: _ctx.verifyCode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.verifyCode) = $event)),
            placeholder: _ctx.t('login.verifyCode'),
            name: "verifyCode",
            tabindex: "2",
            autocomplete: "off",
            onKeyup: _withKeys(_ctx.handleLogin, ["enter"])
          }, null, 8, ["modelValue", "placeholder", "onKeyup"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}